var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"xs":"12","sm":"7","md":"3"}},[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" ارسال اثر با موفقیت صورت گرفت. "),_c('br'),_vm._v(" کد پیگیری شما: "+_vm._s(_vm.submission.uuid)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }